/**
 * localStorage con prefisso e tolleranza agli errori (modalità privata,
 * webview con storage disabilitato): le preferenze locali sono solo comodità.
 */
const PREFIX = "acq:";

export const storage = {
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      window.localStorage.setItem(PREFIX + key, value);
    } catch {
      /* ignorato */
    }
  },
};
